export const MAX_MINT_COUNT = 100
export const CHAIN_ID = 25
export const RPC_URL = "https://evm.cronos.org"
export const INFURA_ID = ""
export const GAS_LIMIT = 300000